<template>
  <header
    class="sticky top-0 z-40 border-b border-slate-200/80 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80"
  >
    <div
      class="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-4 sm:px-6 lg:px-8"
    >
      <router-link
        to="/"
        class="shrink-0 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-4"
        aria-label="SaurusRehv avaleht"
      >
        <img
          class="h-6 w-auto sm:h-7"
          src="@/assets/logo.png"
          alt="SaurusRehv"
          width="2023"
          height="245"
        />
      </router-link>

      <nav aria-label="Peamenüü" class="hidden sm:block">
        <ul class="flex items-center gap-1">
          <li v-for="link in links" :key="link.to">
            <router-link
              :to="link.to"
              :class="[
                'relative inline-flex h-16 items-center px-3 text-sm font-medium transition-colors focus:outline-none focus-visible:text-brand-600',
                isActive(link)
                  ? 'text-brand-600 after:absolute after:inset-x-3 after:bottom-0 after:h-0.5 after:rounded-full after:bg-brand'
                  : 'text-slate-600 hover:text-ink',
              ]"
              :aria-current="isActive(link) ? 'page' : null"
            >
              {{ link.label }}
            </router-link>
          </li>
        </ul>
      </nav>

      <button
        type="button"
        class="-mr-2 inline-flex h-10 w-10 items-center justify-center rounded-lg text-slate-600 transition hover:bg-slate-100 hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-brand sm:hidden"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-controls="mobile-menu"
        :aria-label="menuOpen ? 'Sulge menüü' : 'Ava menüü'"
        @click="menuOpen = !menuOpen"
      >
        <svg
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.75"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            v-if="menuOpen"
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
          <path
            v-else
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          />
        </svg>
      </button>
    </div>

    <nav
      v-show="menuOpen"
      id="mobile-menu"
      aria-label="Peamenüü"
      class="border-t border-slate-200 bg-white sm:hidden"
    >
      <ul class="space-y-1 px-4 py-3">
        <li v-for="link in links" :key="link.to">
          <router-link
            :to="link.to"
            :class="[
              'block rounded-lg px-3 py-2.5 text-base font-medium transition-colors',
              isActive(link)
                ? 'bg-brand-50 text-brand-700'
                : 'text-slate-700 hover:bg-slate-50 hover:text-ink',
            ]"
            :aria-current="isActive(link) ? 'page' : null"
          >
            {{ link.label }}
          </router-link>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      menuOpen: false,
      links: [
        { to: "/", label: "Kodu", exact: true },
        { to: "/rehvid", label: "Rehvid" },
        { to: "/veljed", label: "Veljed" },
        { to: "/contactus", label: "Meist" },
      ],
    };
  },
  watch: {
    "$route.fullPath"() {
      this.menuOpen = false;
    },
  },
  methods: {
    isActive(link) {
      const path = this.$route.path;
      if (link.exact) return path === link.to;
      return path === link.to || path.startsWith(`${link.to}/`);
    },
  },
};
</script>
